import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { UserType } from 'utils/userType';
import { UtilStorage } from 'utils/Storage';
// eslint-disable-next-line import/order
import { store } from './store';
// eslint-disable-next-line import/order
import CombinedProvider from './context/CombinedProvider';
import { BrowserRouter } from 'react-router-dom';

// Busqueda
import 'vendors/fwk';
import 'vendors/fwk.controllers.searchpredictandsuggest';
import 'vendors/jquery.autocompletePredictive';
import 'utils/documentReady';
// Polyfills
import 'utils/polyfills';
import 'components/styles';

// Providers
import EpgProvider from 'providers/epg.provider';
import StartheaderinfoProvider from 'providers/startheaderinfo.provider';
import ContentLoader from 'containers/Player/components/ContentLoader';
import { Navigation } from './routes/Navigation';
import AppSetup from './containers/AppSetup';
import MetricsProvider from 'providers/metrics.provider';

import './index.scss';

// Interceptors
import './api/interceptors/requestInterceptor';
import './api/interceptors/responseInterceptor';
import ProfileProvider from 'providers/profile.provider';
import UserSuspendedProvider from 'providers/usersuspended.provider';
import DeepLinkHandler from 'components/DeeplinkHandler';

//External Logins
import { HBO_LOGIN, ESPN_LOGIN } from '../ExternalLoginApps/constants';
import HboLogin from '../ExternalLoginApps/HboLogin';
import EspnLogin from '../ExternalLoginApps/EspnLogin';
import ForgottenPasswordProvider from 'providers/forgettenPassword.provider';
import StartupErrorBoundary from 'ErrorsBoundary/StartupErrorBoundary';

const ROOT_NODE = document.getElementById('app');
const { pathname } = window.location;

if (pathname.includes(HBO_LOGIN)) {
  render(<HboLogin />, ROOT_NODE);
} else if (pathname.includes(ESPN_LOGIN)) {
  render(<EspnLogin />, ROOT_NODE);
} else {
  //MAIN APP
  window.utils = {
    userType: {},
    getConfig: {},
    storage: new UtilStorage(),
  };

  store.dispatch({
    type: 'middleware',
  });

  window.utils.userType = new UserType(store);
  render(
    <BrowserRouter>
      <Suspense fallback={<ContentLoader />}>
        <Provider store={store}>
          <StartupErrorBoundary>
            <StartheaderinfoProvider>
              <CombinedProvider>
                <UserSuspendedProvider>
                  <ForgottenPasswordProvider>
                    <ProfileProvider>
                      <EpgProvider>
                        <AppSetup>
                          <MetricsProvider>
                            <DeepLinkHandler>
                              <Navigation />
                            </DeepLinkHandler>
                          </MetricsProvider>
                        </AppSetup>
                      </EpgProvider>
                    </ProfileProvider>
                  </ForgottenPasswordProvider>
                </UserSuspendedProvider>
              </CombinedProvider>
            </StartheaderinfoProvider>
          </StartupErrorBoundary>
        </Provider>
      </Suspense>
    </BrowserRouter>,
    ROOT_NODE,
  );
}
